// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isParamString = (x: any): x is string => {
    return typeof x === 'string';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isParamArray = (x: any): x is string[] => {
    return x instanceof Array;
};

export { isParamString, isParamArray };
